<template>
  <div class="drawer-divider">
    <div class="title">
      {{$t(title)}}
    </div>
    <slot></slot>
  </div>
</template>

     
<script>

export default {
  name: 'drawer-divider',
  props:{
    title:{default:""},
  },
  components:{
  },
  data:function(){
    return {
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title{
  padding-bottom:10px;
   font-weight:bold;
}
  .drawer-divider{
    color:#50C0DB;
    padding-bottom:10px;
    padding-top:10px;
   
  }
</style>
